import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin, Youtube } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_akruti-3d-build/artifacts/x72hpznj_Contact%20Us%20%281%29.jpg';

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Projects', path: '/projects' },
  { name: 'Interiors', path: '/interiors' },
  { name: 'Materials', path: '/materials' },
  { name: 'Contact', path: '/contact' },
];

const services = [
  'Residential Construction',
  'Commercial Construction',
  'Interior Design',
  'Renovation',
  'Turnkey Projects',
  'Architectural Planning',
];

const socialLinks = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Youtube, href: '#', label: 'YouTube' },
];

export default function Footer() {
  return (
    <footer className="bg-[#ececec] border-t border-gray-200" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src={LOGO_URL} 
              alt="Akruti Engineers & Builders" 
              className="h-16 w-auto object-contain rounded-lg shadow-lg shadow-black/40"
              style={{ borderRadius: '12px' }}
            />
            <p className="text-gray-600 text-sm leading-relaxed">
              Building your dream space with precision & elegance. Affordable construction, 
              development, and interior design solutions in Karnataka.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 text-gray-600 rounded-full hover:bg-[#C9A646] hover:text-white hover:border-[#C9A646] transition-all duration-300"
                  aria-label={social.label}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-xl text-gray-900 mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-600 hover:text-[#C9A646] transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-xl text-gray-900 mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-gray-600 hover:text-[#C9A646] transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-xl text-gray-900 mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+918880331224"
                  className="flex items-start gap-3 text-gray-600 hover:text-[#C9A646] transition-colors"
                >
                  <Phone size={18} className="mt-1 flex-shrink-0" />
                  <span className="text-sm">+91 88803 31224</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@akrutiengineersandbuilders.com"
                  className="flex items-start gap-3 text-gray-600 hover:text-[#C9A646] transition-colors"
                >
                  <Mail size={18} className="mt-1 flex-shrink-0" />
                  <span className="text-sm break-all">info@akrutiengineersandbuilders.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-600">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span className="text-sm">
                  T NO.2, AT BODHAN TQ ALAND,<br />
                  KALABURAGI, Karnataka, 585101
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Akruti Engineers & Builders. All rights reserved.
            </p>
            <p className="text-gray-600 text-sm">
              We Build Your Dream Space
            </p>
          </div>
          {/* Credits */}
          <div className="mt-6 text-center">
            <p className="text-gray-600 text-xs">
              Designed & Developed by{' '}
              <a 
                href="tel:+919110278059" 
                className="text-[#C9A646] hover:text-[#E6C36A] transition-colors"
              >
                Viral Boostup
              </a>
              {' '}|{' '}
              <a 
                href="tel:+919110278059" 
                className="text-[#C9A646] hover:text-[#E6C36A] transition-colors"
              >
                +91 91102 78059
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
